import React from "react";

import { useRecoilValue } from "recoil";
import { modalState } from "lib/store/common";

import { MyAccount, ChangePassword } from "./MyAccount";
import { Marketing } from "./Marketing";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { TermsOfUse } from "./TermsOfUse";
import { AddCard } from "./AddCard";
import { RefundDetail } from "./RefundDetail";

export const Modals: React.FC = () => {
  const { myAccount, changePassword, pp, term, market, addCard, refundDetail } =
    useRecoilValue(modalState);

  return (
    <>
      {myAccount && <MyAccount />}
      {changePassword && <ChangePassword />}
      {pp && <PrivacyPolicy />}
      {term && <TermsOfUse />}
      {market && <Marketing />}
      {addCard && <AddCard />}
      {refundDetail && <RefundDetail />}
    </>
  );
};
